import { useQuery, useQueryClient } from 'react-query';

import { CreditApi } from 'api/CreditApi';

const CREDITS_REFILL_STATUS_QUERY_KEY = 'credits-refill-status-query';

export const useCreditsRefillStatusQuery = () => {
  return useQuery(
    CREDITS_REFILL_STATUS_QUERY_KEY,
    CreditApi.fetchCreditsRefillStatus,
    {
      retry: false,
    }
  );
};

export const useCreditsRefillStatusQueryCache = () => {
  const queryClient = useQueryClient();

  const getCreditsRefillStatusCache = () => {
    return queryClient.getQueryData<{ enabled: boolean }>(
      CREDITS_REFILL_STATUS_QUERY_KEY
    );
  };

  const setCreditsRefillStatus = (enabled: boolean) => {
    const creditsRefillStatusCache = getCreditsRefillStatusCache();

    if (creditsRefillStatusCache) {
      queryClient.setQueryData<{ enabled: boolean }>(
        CREDITS_REFILL_STATUS_QUERY_KEY,
        () => {
          return {
            enabled,
          };
        }
      );
    }
  };

  return {
    getCreditsRefillStatusCache,
    setCreditsRefillStatus,
  };
};
